var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSolarPower250DpFfffffFill0Wght200Grad0Opsz48(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: "48px",
    viewBox: "0 -960 960 960",
    width: "48px",
    fill: "#FFFFFF",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m128.46-121.54 63.85-319.23h574.61l63.85 319.23H128.46Zm19.23-687.69V-840h108.46v30.77H147.69Zm19.39 656.92h297.54v-112.31H189.85l-22.77 112.31Zm68.46-444.61-22.23-21.23 76.54-76.54 22.23 21.23-76.54 76.54Zm-39.85 301.54h268.93V-410H218.46l-22.77 114.62ZM480-688.46q-63.23 0-106.92-44.42-43.7-44.43-45.39-107.89h30.77q1.46 50.64 36.71 86.09 35.24 35.45 84.92 35.45t84.83-35.45q35.16-35.45 36.62-86.09h30.77q-1.69 63.46-45.39 107.89-43.69 44.42-106.92 44.42Zm0-152.31Zm-15.38 328.46v-108.46h30.76v108.46h-30.76Zm30.76 360h296.77l-22.77-112.31h-274v112.31Zm0-143.07h268.16L740.77-410H495.38v114.62Zm230.62-301-77.31-77.31 21.23-21.23 78.31 76.3L726-596.38Zm-22.15-212.85V-840h108.46v30.77H703.85Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSolarPower250DpFfffffFill0Wght200Grad0Opsz48);
export default __webpack_public_path__ + "static/media/solar_power_250dp_FFFFFF_FILL0_wght200_GRAD0_opsz48.d8af682aecbe8953e212c8509e737eb4.svg";
export { ForwardRef as ReactComponent };